<template>
	<div>
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions><el-button plain size="small" type="warning" class="el-icon-refresh-right" :loading="initLoading" @click="handleInit">重新初始化统计</el-button></template>
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.belongStoreKeyId" filterable placeholder="请选择门店" clearable size="small" @change="inputChange">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="顾客姓名：">
				<el-input v-model="formInline.customerName" clearable size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="电话：">
				<el-input v-model="formInline.phone" clearable size="small" placeholder="请输入电话" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			</lcsj-filter>
		<div class="statistic-tip">
			统计口径：系统内所有加工订单（不含售后单、已退回、撤单）中，存在任意
			<span style="color: var(--app-primary-text); font-weight: bold">连续 30 天</span>
			内创建
			<span style="color: var(--app-danger-text); font-weight: bold">2 个及以上</span>
			加工订单的顾客（点击订单编号可查看订单详情）
		</div>
		<STable :columns="columnsData" :data="listData" :loading="loading" border height="520">
			<template #orderNos>
				<el-table-column align="center" label="周期内订单编号" min-width="260">
					<template #default="scope">
						<template v-if="scope.row.orderNos">
							<el-link
								v-for="(no, idx) in scope.row.orderNos.split(',')"
								:key="idx"
								type="primary"
								:underline="false"
								style="margin-right: 8px"
								@click="handleViewOrder(scope.row, idx)"
							>
								{{ no }}
							</el-link>
						</template>
					</template>
				</el-table-column>
			</template>
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		<!-- 订单详情弹窗 -->
		<storeDetail ref="storeDetail" :dialog-mode="true" :show-actions="false"></storeDetail>
	</div>
</template>

<script>
import { getCustomerOrderStatisticPageList, initCustomerOrderStatistic } from "@/api/baseDataApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import storeDetail from "@/views/baseData/storeOrder/order/storeDtl.vue";
export default {
	data() {
		return {
			pageShow: true,
			loading: false,
			initLoading: false,
			listData: [],
			storeList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				customerName: "",
				phone: "",
				belongStoreKeyId: ""
			},
			columnsData: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80"
				},
				{
					prop: "customerName",
					label: "顾客姓名",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "phone",
					label: "联系电话",
					align: "center",
					width: "130"
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					align: "center",
					width: "150"
				},
				{
					prop: "orderCount",
					label: "周期内加工订单数",
					align: "center",
					width: "140"
				},
				{
					slot: "orderNos",
					label: "周期内订单编号",
					align: "center",
					minWidth: "260"
				},
				{
					prop: "firstOrderDate",
					label: "最早下单时间",
					align: "center",
					width: "160"
				},
				{
					prop: "lastOrderDate",
					label: "最晚下单时间",
					align: "center",
					width: "160"
				},
				{
					prop: "updateTime",
					label: "统计时间",
					align: "center",
					width: "160"
				}
			]
		};
	},
	components: {
		storeDetail
	},
	created() {
		this.GetOrganizationListByConfig();
		this.getListData();
	},
	methods: {
		// 查看订单详情（orderKeyIds 与 orderNos 按创建时间一一对应，按下标取）
		handleViewOrder(row, idx) {
			const keyIds = (row.orderKeyIds || "").split(",");
			const keyId = keyIds[idx];
			if (!keyId) {
				this.$message.warning("未获取到订单信息");
				return;
			}
			this.$refs.storeDetail.showSeeDetailDialog({ keyId: keyId, state: 0, linkOrderKeyId: "" }, 1);
		},
		// 获取门店列表
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrganizationListByConfig(paramer).then((res) => {
				if (res.code == 1) {
					this.storeList = res.data;
				}
			});
		},
		// 获取统计数据
		getListData() {
			this.loading = true;
			getCustomerOrderStatisticPageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber || 0;
					} else {
						this.listData = [];
						this.$message.error(res.msg || "查询失败");
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 搜索
		inputChange() {
			this.formInline.pageIndex = 1;
			this.getListData();
		},
		// 重置
		clearAll() {
			this.formInline = {
				pageIndex: 1,
				pageSize: 10,
				customerName: "",
				phone: "",
				belongStoreKeyId: ""
			};
			this.getListData();
		},
		// 分页（Pagination 组件回传字段为 currentPage）
		callFather(pager) {
			this.formInline.pageIndex = pager.currentPage || pager.pageIndex || 1;
			this.formInline.pageSize = pager.pageSize;
			this.getListData();
		},
		// 重新初始化统计（处理历史数据，幂等）
		handleInit() {
			this.$confirm("将重算所有顾客的加工/销售订单数量，并重建顾客订单统计表，确定执行？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.initLoading = true;
					initCustomerOrderStatistic({})
						.then((res) => {
							this.initLoading = false;
							if (res.code == 1) {
								const d = res.data || {};
								this.$message.success(
									`处理完成：顾客${d.customerTotal || 0}个，加工订单${d.processOrderTotal || 0}单，销售订单${
										d.salesOrderTotal || 0
									}单，命中统计${d.hitCount || 0}人`
								);
								this.getListData();
							} else {
								this.$message.error(res.msg || "初始化失败");
							}
						})
						.catch(() => {
							this.initLoading = false;
						});
				})
				.catch(() => {});
		}
	}
};
</script>

<style scoped lang="scss">
.statistic-tip {
	margin: 0 0 10px 10px;
	font-size: 13px;
	color: var(--app-text-muted);
}
</style>
